import api from '../../../api/parametres/_mixdata'

const state = () => ({
    type_champs: [],
    liste_occurences: [],
    liste_champs: [],
    champs_exm_clinique: [],
    champs_exm_clinique_historique: [],
    champ_taux_assurance: [],

    // PARAM - Liste des champs ATCD ENF pers. physiologique
    liste_atcd_enf_physio: [],

    // Consultation en cours - Liste des champs ATCD Enf pers. physio
    champ_atcd_pers_physio: [],
    champ_historique_atcd_pers_physio: [],           //  Historique

    liste_type_mix_datas: [],
    liste_mode_administration: {}
})

// getters
const getters = {
    type_champs: (state) => {
        return state.type_champs
    }, 

    liste_occurences: (state) => {
        return state.liste_occurences
    }, 

    liste_champs: (state) => {
        return state.liste_champs
    },

    liste_atcd_enf_physio: (state) => {
        return state.liste_atcd_enf_physio
    },

    champ_atcd_pers_physio: (state) => {
        return state.champ_atcd_pers_physio
    },

    champ_historique_atcd_pers_physio: (state) => {
        return state.champ_historique_atcd_pers_physio
    },
    
    champs_exm_clinique: (state) => {
        return state.champs_exm_clinique
    },

    champs_exm_clinique_historique: (state) => {
        return state.champs_exm_clinique_historique
    },

    champ_taux_assurance: (state) => {
        return state.champ_taux_assurance
    },

    liste_type_mix_datas: (state) => {
        return state.liste_type_mix_datas
    },

    liste_mode_administration: (state) => {
        return state.liste_mode_administration
    },
}

// mutations
const mutations = {
    SET_LISTE_TYPE_CHAMPS(state, type_champ) {
        state.type_champs = type_champ;
    },

    SET_OCCURENCES(state, occurences) {
        state.liste_occurences = occurences;
    },

    SET_LISTE_CHAMPS(state, champ) {
        state.liste_champs = champ;
    },

    SET_LISTE_ATCD_ENF_PHYSIOLOGIQUE(state, champs) {
        state.liste_atcd_enf_physio = champs;
    },

    SET_CHAMP_ATCD_ENF_PHYSIOLOGIQUE(state, champs) {
        state.champ_atcd_pers_physio = champs;
    },

    SET_HISTORIQUE_CHAMP_ATCD_ENF_PHYSIOLOGIQUE(state, champs) {
        state.champ_historique_atcd_pers_physio = champs;
    },

    SET_CHAMPS_EXAM_CLINIQUE(state, champ) {
        state.champs_exm_clinique = champ;
    },

    SET_HISTORIQUE_CHAMPS_EXAM_CLINIQUE(state, champ) {
        state.champs_exm_clinique_historique = champ;
    },

    SET_CHAMP_TAUX_ASSURANCE(state, champ) {
        state.champ_taux_assurance = champ;
    },

    SET_LISTE_TYPE_MIX_DATAS(state, data) {
        state.liste_type_mix_datas = data;
    },

    SET_LISTE_MODE_ADMINISTRATION(state, data) {
        state.liste_mode_administration = data;
    },
}

// actions
const actions = {
    /**
     * Selectionne les types de champs (Texte, Nombre , Zone de texte, etc.)
     * @param {*} param0 
     * @returns 
     */
    getTypeChamps({commit}) {
        return new Promise((resolve, reject) => {
            api.getTypeChamps().then(
                response => {
                    resolve(response)
                    commit('SET_LISTE_TYPE_CHAMPS', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getDynamicField({commit}, data_type) {
        return new Promise((resolve, reject) => {
            api.getDynamicField(data_type).then(
                response => {
                    resolve(response)
                    commit('SET_LISTE_ATCD_ENF_PHYSIOLOGIQUE', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    /**
     * Liste des occurences des champs
     * @param {*} param0 
     * @returns 
     */
     getListeOccurences({commit}) {
        return new Promise((resolve, reject) => {
            api.getListeOccurences().then(
                response => {
                    resolve(response)
                    commit('SET_OCCURENCES', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveChamp({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveChamp(data).then(
                response => {
                    dispatch('getTypeChamps')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    // 
    saveDynamicalField({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveDynamicalField(data).then(
                response => {
                    dispatch('getDynamicField', data.data_type)
                    // dispatch('getTypeChamps')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeChamps({commit}, data_type) {
        return new Promise((resolve, reject) => {
            api.getListeChamps(data_type).then(
                response => {
                    resolve(response)
                    commit('SET_LISTE_CHAMPS', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getChampExamClinique({commit}, data) {
        return new Promise((resolve, reject) => {
            api.getChampExamClinique(data).then(
                response => {
                    resolve(response)

                    if (data.en_cours == true) {
                        commit('SET_CHAMPS_EXAM_CLINIQUE', response)
                    } else {
                        commit('SET_HISTORIQUE_CHAMPS_EXAM_CLINIQUE', response)
                    }
                    
                }, error => {
                    reject(error)
                }
            )
        })
    },

    /**
     * Récupère la liste des champs ATCD ENF Pers. physiologiques
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    getChampAtcdEnfpersPhysio({commit}, data) {
        return new Promise((resolve, reject) => {
            api.getChampAtcdEnfpersPhysio(data).then(
                response => {
                    resolve(response)

                    if (data.en_cours == true) {
                        commit('SET_CHAMP_ATCD_ENF_PHYSIOLOGIQUE', response)
                    } else {
                        commit('SET_HISTORIQUE_CHAMP_ATCD_ENF_PHYSIOLOGIQUE', response)
                    }
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getChampsTauxAssurance({commit}, assurance_id) {
        return new Promise((resolve, reject) => {
            api.getChampsTauxAssurance(assurance_id).then(
                response => {
                    resolve(response)
                    commit('SET_CHAMP_TAUX_ASSURANCE', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveTauxChamp({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveTauxChamp(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    /**
     * Definir un taux ( Prestation + plafond )
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    saveTauxCouverture({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveTauxCouverture(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteTauxCouverture({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteTauxCouverture(data).then(
                response => {
                    dispatch('getChampsTauxAssurance', data.assurance_id)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeTypeMixData({commit}, data_type) {
        return new Promise((resolve, reject) => {
            api.getListeTypeMixData(data_type).then(
                response => {
                    resolve(response)
                    commit('SET_LISTE_TYPE_MIX_DATAS', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeModeAdministration({commit}) {
        return new Promise((resolve, reject) => {
            api.getListeModeAdministration().then(
                response => {
                    resolve(response)
                    commit('SET_LISTE_MODE_ADMINISTRATION', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveModeAdministration({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveModeAdministration(data).then(
                response => {
                    resolve(response)
                    dispatch
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteModeAdministration({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deleteModeAdministration(data).then(
                response => {
                    resolve(response)
                    dispatch
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deactivateChamp({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deactivateChamp(data).then(
                response => {
                    resolve(response)
                    dispatch
                }, error => {
                    reject(error)
                }
            )
        })
    },

    reorderFields({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.reorderFields(data).then(
                response => {
                    resolve(response)
                    dispatch
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}